import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const embed = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.EMBED> =>
	createModel({
		type: COMPONENT_TYPE.EMBED,
		componentProps: {
			styles: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {},
				},
			},
			other: {},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.EMBED>;
